export default __webpack_public_path__ + "static/media/advicegradissuegfx-15.f195798d.png";